/**
 * This is the Billing Group Pricing Tables Middleware.
 * APIs are called for CRUD operations on the pricing schemes and country pricing associated with the BG.
 * @param store
 * @returns {function(*): function(...[*]=)}
 */

import {
    addBGPricingCountry,
    editBGPricingCountry, fetchBillingGroupDetail,
} from "veritas/billing-groups/actions/BillingGroupActions";
import {
    setBGCountryPricing,
    fetchBGPricingTables, deleteBGPricingWarning, closeModalBGCountryPricing
} from "veritas/billing-groups/actions/BillingGroupPricingActions";
import { apiActionsBillingGroupPricing } from "middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import { BGPricingActionTypes } from "veritas/billing-groups/constants/BillingGroupActionConstants";

import { displayDuplicateMessage } from "common/marvel-reducers/formMessageActions";

import API from 'common/utils/API';
import * as Validation from "common/utils/Validation";

const apiMiddlewareBillingGroupsPricing = (store) => (next) => (action) => {

    switch (action.type) {

        case apiActionsBillingGroupPricing.GET: {
            next(action);
            const { billingGroupID, authToken } = action.payload;
            API.getBGPricingScheme(authToken.idToken, billingGroupID)
                .then(res => {
                    store.dispatch(setBGCountryPricing(res.data))
                }).catch(err => {
                console.error(err);
            });
            break;
        }

        case apiActionsBillingGroupPricing.POST: {
            next(action);

            const { authToken, pricingSchemeObject } = action.payload;
            if (authToken.account.name) {
                pricingSchemeObject.updated_by = authToken.account.name;
            }
            API.postBGPricingScheme(authToken.idToken, pricingSchemeObject)
                .then(res => {
                    store.dispatch(closeModalBGCountryPricing());
                    store.dispatch(fetchBillingGroupDetail(res.data.billing_group));
                    store.dispatch(fetchBGPricingTables(res.data.billing_group));
                }).catch(error => {
                    if (error.response.status === 409) {
                        const message = ["This country already exists in the pricing table."]
                        store.dispatch(displayDuplicateMessage(message, true));
                    }
                    console.error(error);
                })

            break;
        }

        case apiActionsBillingGroupPricing.PUT: {
            next(action);

            const { authToken, countryPricingID, pricingSchemeObject } = action.payload;
            if (authToken.account.name) {
                pricingSchemeObject.updated_by = authToken.account.name;
            }
            API.putBGPricingScheme(authToken.idToken, countryPricingID, pricingSchemeObject)
                .then(res => {
                    store.dispatch(closeModalBGCountryPricing());
                    store.dispatch(fetchBillingGroupDetail(res.data.billing_group));
                    store.dispatch(fetchBGPricingTables(res.data.billing_group));
                })
                .catch(error => {
                    if (error.response.status === 409) {
                        const message = ["This country already exists in the pricing table."]
                        store.dispatch(displayDuplicateMessage(message, true));
                    }
                    console.error(error);
                })

            break;
        }

        case apiActionsBillingGroupPricing.DELETE: {
            next(action);

            const { authToken, billingGroupID, countryPricingID } = action.payload;
            API.deleteBGCountryPricing(authToken.idToken, countryPricingID)
                .then(res => {
                    store.dispatch(deleteBGPricingWarning());
                    store.dispatch(fetchBillingGroupDetail(billingGroupID));
                    store.dispatch(fetchBGPricingTables(billingGroupID))
                })
                .catch(err => console.error(err));

            break;
        }

        case BGPricingActionTypes.SUBMIT_BG_PRICING_FORM: {
            next(action);

            const pricingSchemeObject = action.payload;
            const countryPricingID = pricingSchemeObject.country_pricing_id;
            if (Validation.validateBGPricingForm(pricingSchemeObject)) {
                if (countryPricingID) {
                    store.dispatch(editBGPricingCountry(countryPricingID, pricingSchemeObject));
                } else {
                    // make the payload compatible with what the API expects
                    pricingSchemeObject.billing_group = pricingSchemeObject.billing_group_id;
                    delete pricingSchemeObject.billing_group_id;
                    store.dispatch(addBGPricingCountry(pricingSchemeObject));
                }
            }
            break;
        }

        default: next(action);
    }
}

export default apiMiddlewareBillingGroupsPricing;
